import React from 'react';
import Button from 'app/components/button';

const CollectVoucher = ({
  values,
  setValues,
  isFilterOpen,
  setIsFilterOpen,
  onSubmit,
}) => {
  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.target;
    if (form.checkValidity()) {
      onSubmit({ values });
    } else {
      form.reportValidity();
    }
  };

  const handleCancel = () => {
    setIsFilterOpen(false);
  };

  return (
    <div className={`offcanvas-modal ${isFilterOpen ? 'open' : ''}`}>
      <div className='offcanvas-modal-content'>
        <div className='offcanvas-modal-header'>
          <h4>Collect Voucher</h4>
          <button
            className='close-button'
            onClick={() => setIsFilterOpen(false)}
          >
            ×
          </button>
        </div>

        <form className='offcanvas-modal-body' onSubmit={handleSubmit}>
          <div className='offcanvas-item'>
            <label>Phone Number:</label>
            <input
              required
              type='number'
              value={values?.phoneNumber}
              disabled
            />
          </div>
          <div className='offcanvas-item'>
            <label>Voucher Collection Code :</label>
            <input
              type='text'
              value={values?.voucherCode}
              required
              onChange={(e) =>
                setValues({ ...values, voucherCode: e.target.value })
              }
            />
          </div>
          <div className='offcanvas-item'>
            <label>Voucher Serial Number::</label>
            <input
              required
              type='text'
              onChange={(e) =>
                setValues({ ...values, serialNumber: e.target.value })
              }
            />
          </div>

          <div className='offcanvas-actions'>
            <Button
              className='mt1'
              onClick={() => {}}
              variant='Save'
              name='Submit'
            />
            <Button
              className='mt-1 cancel-button'
              onClick={handleCancel}
              variant='Cancel'
              name='Cancel'
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default CollectVoucher;
